import { useEffect, useState } from "react";
import { RegisterModel } from "../../models/RegisterModel";
import { AsyncStorageKeys, Pages, ProfileNameState } from "../../Types";
import { HomeScreenNavigationProp, ProfileNameSelectScreenNavigationProp, routeHome, routeProfileNameSelect } from "../../Routes";
import { useNavigation } from "@react-navigation/native";
import { ACCOUNT_EXIST, Code_OK, DEVICE_NOT_ENTITLE, getPresignedUrl, HWID_EXIST } from "../../networking/networking";
import { redeemVoucherCode, registerAccountNoVoucherNeeded, validateVoucher } from "../../services/loginService";
import { voucherValidate } from "../../utils/ValidateResponse";
import {
	globalAny,
	pushProfileNameStateToBrowserHistory,
	validateEmail,
	generateDeviceInfo,
	isInCarScreen,
	processToastMessage,
	hasValue,
	toReversed,
	recordAnalytics,
} from "../../utils/Utils";
import { AppLogger } from "../../utils/AppLogger";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import ComponentThemeType from "../../models/ComponentTheme";
import TouchableButton from "../../components/TouchableButton";
import useLoginStore from "../../store/useLogin.store";
import AsyncStorage from "@react-native-async-storage/async-storage";
import PrivacyPolicyButton from "../../components/PrivacyPolicyButton";
import useMqttStore from "../../store/useMqtt.store";
import useGenericContentStore from "../../store/genericContent.store";
import { automaticVoucherRedemption, setUserOptions } from "../../services/accountService";
import useOtherDataStore from "../../store/useOtherData.store";
import useAcceptDataStore from "../../store/useAcceptData.store";
import UserOptionProps from "../../models/UserOptionProps";
import { UserOptionSettings } from "../../enums/UserOptionSettings";
import { AccountFormContentProps, FormModel, Props } from "./model";
import {
	StyledButtonContainer,
	StyledNarrowButton,
	StyledNarrowCreateButton,
	StyledNarrowTextContent,
	StyledWideContent,
	StyledWideFooter,
} from "./styled";
import Toast from "../../components/Toast";
import WideCreateAccountWrapper from "../../components/Layout/WideCreateAccountWrapper";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import NarrowCreateAccountWrapper from "../../components/Layout/NarrowCreateAccountWrapper";
import AccountFormContent from "./AccountFormContent";
import { TouchableButtonDataProps } from "../../models/TouchableButtonDataProps";
import CustomizeDialogBox from "../../components/DialogMessageBox/CustomizeDialogBox";
import Modal from "../../components/Modal";
import { EventType } from "../../enums/EventType";

let saveAccount: any;
const AGE_ALLOWED_MIN = 18;
const emailUserPart = '([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)';
const emailQuoted = '".+"';
const emailIpAddress = "\\[\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\]";
const emailDomain = "([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}";
const emailPattern = new RegExp(`^(${emailUserPart}|${emailQuoted})@(${emailIpAddress}|${emailDomain})$`);
const birthdayPart = "^[0-9/]+$";
const birthdayPattern = new RegExp(birthdayPart);

const CreateAccountForm = (props: Props) => {
	// Account info & form
	const [accountToSave, setAccountToSave] = useState<RegisterModel | null>(null);
	const [form, setForm] = useState<FormModel>({
		voucher: { value: "", valid: true },
		email: { value: "", valid: true },
		password: { value: "", valid: true },
		confirmPassword: { value: "", valid: true },
		month: { value: 0, valid: true },
		year: { value: 0, valid: true },
		birthday: { value: "", valid: true },
		ageChecked: false,
	});

	// UI state
	const [showDateModal, setShowDateModal] = useState(false);
	const [showVoucherToast, setShowVoucherToast] = useState(false);
	const [loading, setLoading] = useState(false);
	const [readyToSaveAccount, setReadyToSaveAccount] = useState(false);
	const [passwordValidated, setPasswordValidated] = useState(false);
	const [visible, setVisible] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const [labelText, setLabelText] = useState<any>();
	const [errorSummary, setErrorSummary] = useState("");

	// User info
	const [email, setEmail] = useState("");
	const [birthday, setBirthday] = useState("");
	const birthdayValidated = birthday.length === 7;
	const [secureTextEntry, setSecureTextEntry] = useState(true);
	const [automaticVoucherCode, setAutomaticVoucherCode] = useState<any>({});

	// Date picker
	const [lastUsedDate, setLastUsedDate] = useState<MaterialUiPickersDate | null>(null);

	// External stores
	const { googleData, videoAnalyticsData } = useOtherDataStore();
	const { acceptData } = useAcceptDataStore();
	const { presignedUrl, setPresignedUrl, setDeviceInfo } = useMqttStore((state: any) => ({
		presignedUrl: state.presignedUrl,
		setPresignedUrl: state.setPresignedUrl,
		setDeviceInfo: state.setDeviceInfo,
	}));
	const { setIsLogin, isNarrow } = useGenericContentStore((state: any) => ({
		setIsLogin: state.setIsLogin,
		isNarrow: state.isNarrow,
	}));
	const { setIsLoggedIn, isLoggedIn } = useLoginStore((state: any) => ({
		setIsLoggedIn: state.setIsLoggedIn,
		isLoggedIn: state.isLoggedIn,
	}));

	// Navigation
	const navigationProfileNameSelectScreen = useNavigation<ProfileNameSelectScreenNavigationProp>();
	const navigationHomeScreen = useNavigation<HomeScreenNavigationProp>();

	// Helper
	const onDismissSnackBar = () => setVisible(false);
	const errorEmail = globalAny.language.enter_valid_email;
	const errorPassword = globalAny.language.password_rules;
	const touchableButtonData: TouchableButtonDataProps[] = [
		{
			title: globalAny.language.back,
			type: ComponentTypeEnum.Secondary,
			disabled: loading,
			leftText: isNarrow,
			onPress: props.onPressBack ?? (() => {}),
			isLoading: false,
		},
		{
			title: globalAny.language.submit,
			type: ComponentTypeEnum.Primary,
			disabled: loading,
			leftText: isNarrow,
			onPress: () => {
				validateForm();
			},
			isLoading: loading,
		},
	];

	/**
	 * Renders a themed `TouchableButton` for create account or related actions.
	 *
	 * @param {Object} props - Props for the button.
	 * @param {string} props.title - The text to display inside the button.
	 * @param {string} props.type - The button type/style.
	 * @param {string} [props.leftText] - Optional text displayed on the left side of the button.
	 * @param {boolean} [props.disabled=false] - Whether the button is disabled.
	 * @param {boolean} [props.isLoading=false] - Whether to show a loading indicator.
	 * @param {() => void} props.onPress - Callback invoked when the button is pressed.
	 *
	 * @returns {JSX.Element} A styled `TouchableButton` component.
	 */
	const renderTouchableButtonData = ({ title, type, leftText, disabled, isLoading, onPress }: TouchableButtonDataProps) => (
		<TouchableButton
			key={`create-account-touchable-${title}`}
			componentTheme={ComponentThemeType.VinFast}
			type={type}
			onPress={onPress}
			disabled={disabled}
			leftText={leftText}
			loadingIndicator={isLoading}
		>
			{title}
		</TouchableButton>
	);

	/**
	 * Checks if a given year and month form a valid date.
	 *
	 * Validity criteria:
	 * - Month must be between 1 and 12 (inclusive).
	 * - Year must be greater than 1900 and less than the current year.
	 *
	 * @param {number | string} year - The year to validate.
	 * @param {number | string} month - The month to validate.
	 * @returns {boolean} `true` if the year and month form a valid date, otherwise `false`.
	 */
	const isValidDate = (year: number | string, month: number | string) => {
		const numYear = Number(year);
		const numMonth = Number(month);
		const currentYear = new Date().getFullYear();

		return numMonth >= 1 && numMonth <= 12 && numYear > 1900 && numYear < currentYear;
	};

	/**
	 * Validates if a birthday meets the minimum allowed age.
	 *
	 * Behavior:
	 * - Calculates the difference in years and months between the current date and the provided year/month.
	 * - Returns `true` if:
	 *   - The age in years is greater than `AGE_ALLOWED_MIN`, or
	 *   - The age in years equals `AGE_ALLOWED_MIN` and the months difference is positive.
	 *
	 * @param {number | string} year - The birth year to validate.
	 * @param {number | string} month - The birth month (0-based index: 0 = January) to validate.
	 * @returns {boolean} `true` if the birthday meets the minimum age requirement, otherwise `false`.
	 */
	const validateBirthday = (year: number | string, month: number | string) => {
		let CurrentDate = new Date(); // defaults to today
		let CurrentYear = CurrentDate.getFullYear();
		let CurrentMonth = CurrentDate.getMonth();

		let AgeYears = CurrentYear - Number(year);
		let AgeMonths = CurrentMonth - Number(month);

		return AgeYears > AGE_ALLOWED_MIN || (AgeYears == AGE_ALLOWED_MIN && AgeMonths > 0);
	};

	/**
	 * Validates the email address from the form.
	 *
	 * Behavior:
	 * - Retrieves the `email` value from the `form`.
	 * - Converts it to a string (or defaults to an empty string if undefined).
	 * - Returns `true` if the email is non-empty and matches the `emailPattern` regex.
	 *
	 * @returns {boolean} `true` if the email address is valid, otherwise `false`.
	 */
	const validateEmailAddress = () => {
		const email = form.email.value?.toString() ?? "";
		return email.length > 0 && emailPattern.test(email);
	};

	/**
	 * Validates a password based on minimum length requirement.
	 *
	 * Behavior:
	 * - Returns `true` if the password length is at least 6 characters.
	 *
	 * @param {string} password - The password string to validate.
	 * @returns {boolean} `true` if the password is valid, otherwise `false`.
	 */
	const validatePassword = (password: string) => password.length >= 6;

	/**
	 * Asynchronously validates the voucher code entered in the form.
	 *
	 * Behavior:
	 * - Retrieves the voucher value from `form.voucher`.
	 * - Calls the `validateVoucher` API to check the voucher.
	 * - Sets `valid` to `true` if the voucher is valid; otherwise sets an appropriate `errorMessage`.
	 * - If an exception occurs during validation, sets a default error message (`voucherValidate(40004)`).
	 * - Returns an object containing both `valid` and `errorMessage`.
	 *
	 * @async
	 * @returns {Promise<{ valid: boolean; errorMessage: string }>} The result of the voucher validation.
	 */
	const validateVoucherCode = async () => {
		let valid = false;
		let errorMessage = "";

		try {
			const voucherEndpoint: any = await validateVoucher(form.voucher.value.toString());

			if (voucherEndpoint.response) {
				valid = true;
			} else {
				errorMessage = voucherValidate(voucherEndpoint.responseCode);
			}
		} catch {
			errorMessage = voucherValidate(40004);
		}

		return { valid, errorMessage };
	};

	const onEnterEmail = (event: any) => {
		setEmail(event);
		if (!validateEmail(event)) {
			return setForm({ ...form, email: { ...form.email, valid: false, errorMessage: errorEmail } });
		}
		setForm({ ...form, email: { ...form.email, valid: true, value: event } });
	};

	/**
	 * Handles email input changes and updates form validation state.
	 *
	 * Behavior:
	 * - Updates the email state with the current input.
	 * - Validates the email using `validateEmail`.
	 * - If invalid, updates the form state to mark the email as invalid and sets an error message.
	 * - If valid, updates the form state to mark the email as valid and stores the input value.
	 *
	 * @param {string} event - The current value of the email input field.
	 * @returns {void}
	 */
	const onEnterPassword = (event: string) => {
		if (!validatePassword(event)) {
			setPasswordValidated(false);
			return setForm({ ...form, password: { ...form.password, valid: false, errorMessage: errorPassword } });
		}
		setPasswordValidated(true);
		setForm({ ...form, password: { ...form.password, valid: true, value: event } });
	};

	/**
	 * Handles birthday input changes and updates form validation state.
	 *
	 * Behavior:
	 * - Checks if the input length is at least 7 characters (assumes format like "MM/YYYY").
	 * - If valid, updates the form state to mark the birthday as valid and clears any error message.
	 * - If invalid, updates the form state to mark the birthday as invalid and sets an appropriate error message.
	 * - Logs the current form state using `AppLogger`.
	 *
	 * @param {string} event - The current value of the birthday input field.
	 * @returns {void}
	 */
	const onEnterBirthday = (event: string) => {
		if (event.length >= 7) {
			return setForm({ ...form, birthday: { ...form.birthday, valid: true, errorMessage: "" } });
		}

		setForm({ ...form, birthday: { ...form.birthday, valid: false, errorMessage: globalAny.language.enter_valid_birthday } });
	};

	/**
	 * Processes the login for a given account.
	 *
	 * Behavior:
	 * - Retrieves a presigned URL via `getPresignedUrl` and stores it in state (`setPresignedUrl`).
	 * - Saves the account email to `AsyncStorage` under `AsyncStorageKeys.email`.
	 * - Hides the voucher toast (`setShowVoucherToast(false)`).
	 * - Shows the welcome splash screen via `props.setShowWelcomeSplash(true)`.
	 *
	 * @async
	 * @param {Object} saveAccount - The account information to process.
	 * @param {string} saveAccount.email - The email of the account being logged in.
	 * @returns {Promise<void>}
	 */
	const processLogin = async (saveAccount: any) => {
		const presignedService = await getPresignedUrl();
		setPresignedUrl(presignedService);
		AsyncStorage.setItem(AsyncStorageKeys.email, saveAccount?.email);
		setShowVoucherToast(false);
		props.setShowWelcomeSplash(true);
	};

	/**
	 * Processes and saves the user's data options asynchronously.
	 *
	 * Behavior:
	 * - Creates a `UserOptionProps` object for accepting data based on `acceptData` state.
	 * - Creates an array of `UserOptionProps` for other options:
	 *   - Google Analytics (`googleData`)
	 *   - Video Analytics (`videoAnalyticsData`)
	 * - Calls `setUserOptions` to save the accept data option and other options.
	 *
	 * @async
	 * @returns {Promise<void>}
	 */
	const processUserOptions = async () => {
		const accept: UserOptionProps = {
			optionId: UserOptionSettings.AcceptData,
			isEnabled: acceptData,
			optionResponseId: 0,
		};

		const other: UserOptionProps[] = [
			{
				optionId: UserOptionSettings.GoogleAnalytics,
				isEnabled: googleData,
				optionResponseId: 0,
			},
			{
				optionId: UserOptionSettings.VideoAnalytics,
				isEnabled: videoAnalyticsData,
				optionResponseId: 0,
			},
		];

		await setUserOptions(accept, other);
	};

	/**
	 * Handles the UI updates when network connection is lost.
	 *
	 * Behavior:
	 * - Prevents account saving by setting `setReadyToSaveAccount(false)`.
	 * - Updates the label text to indicate a retry (`label_retry`).
	 * - Stops any loading indicators (`setLoading(false)`).
	 * - Shows a toast message notifying the user about the lost network connection.
	 * - Sets the toast visibility to true (`setVisible(true)`).
	 *
	 * @returns {void}
	 */
	const networkConnectionLost = () => {
		setReadyToSaveAccount(false);
		setLabelText(globalAny.language.label_retry);
		setLoading(false);
		setToastMessage(globalAny.language.network_connection_lost);
		setVisible(true);
	};

	/**
	 * Saves the device information and updates the global profile name.
	 *
	 * Behavior:
	 * - Stores the device ID in `AsyncStorage` under `AsyncStorageKeys.deviceId`.
	 * - Updates the global profile name (`globalAny.profileName`) with the device name.
	 *
	 * @async
	 * @param {Object} deviceInfo - The device information object.
	 * @param {string} deviceInfo.deviceId - The unique ID of the device.
	 * @param {string} deviceInfo.deviceName - The display name of the device.
	 * @returns {Promise<void>}
	 */
	const setProfileName = async (deviceInfo: any) => {
		await AsyncStorage.setItem(AsyncStorageKeys.deviceId, deviceInfo.deviceId);
		globalAny.profileName = deviceInfo.deviceName;
	};

	/**
	 * Updates the device information and profile name.
	 *
	 * Behavior:
	 * - Generates device information using `generateDeviceInfo` with the given `profileName`.
	 * - Updates the local device state using `setDeviceInfo`.
	 * - Updates the global profile name and stores the device ID using `setProfileName`.
	 *
	 * @param {string} profileName - The name to assign to the device profile.
	 * @returns {void}
	 */
	const updateDevice = (profileName: any) => {
		const deviceInfo = generateDeviceInfo(profileName);
		setDeviceInfo(deviceInfo);
		setProfileName(deviceInfo);
	};

	/**
	 * Toggles the visibility of a secure text input (e.g., password field).
	 *
	 * Behavior:
	 * - Inverts the current `secureTextEntry` state to show or hide the text.
	 *
	 * @returns {void}
	 */
	const onPressEye = () => setSecureTextEntry((prev) => !prev);

	/**
	 * Formats a date of birth input and updates the state.
	 *
	 * Behavior:
	 * - Ignores input longer than 7 characters.
	 * - Removes any characters that are not digits or '/'.
	 * - Automatically inserts a '/' after the first 4 digits if missing (for "YYYY/MM" format).
	 * - Updates the `birthday` state with the formatted value.
	 * - Calls `onEnterBirthday` with the formatted value to trigger validation.
	 *
	 * @param {string} date - The raw date input from the user.
	 * @returns {void}
	 */
	const formatDOB = (date: string) => {
		if (date.length > 7) return;

		const cleaned = date.replace(/[^0-9/]/g, "");
		const formatted = cleaned.length > 4 && cleaned.length < 7 && !cleaned.includes("/") ? `${cleaned.slice(0, 4)}/${cleaned.slice(4)}` : cleaned;

		setBirthday(formatted);
		onEnterBirthday(formatted);
	};

	/**
	 * Handles toast button presses.
	 *
	 * Behavior:
	 * - Checks if the pressed command matches the retry label (`label_retry`).
	 * - If it matches:
	 *   - Makes the toast visible (`setVisible(true)`).
	 *   - Calls `validateForm()` to re-validate the form inputs.
	 *
	 * @param {string} command - The label or command from the toast button.
	 * @returns {void}
	 */
	const onPressToast = (command: string) => {
		if (command !== globalAny.language.label_retry) return;
		setVisible(true);
		validateForm();
	};

	/**
	 * Validates all user input fields in the form asynchronously.
	 *
	 * Behavior:
	 * - Parses the `birthday` input into `year` and `month` and updates the form state.
	 * - Validates individual fields:
	 *   - Email (`validateEmailAddress`)
	 *   - Password (`validatePassword`)
	 *   - Confirm password (matches password)
	 *   - Birthday (valid date and minimum age)
	 * - Sets appropriate error messages for invalid fields:
	 *   - Invalid birthday format or age.
	 *   - Invalid email.
	 *   - Password rules violation.
	 *   - Passwords mismatch.
	 * - Checks voucher validity if a voucher code is entered and automatic voucher code is disabled.
	 * - Updates the form state with validation results for all fields.
	 * - Sets `setReadyToSaveAccount(true)` if all required fields are valid, otherwise stops loading (`setLoading(false)`).
	 *
	 * @async
	 * @returns {Promise<void>}
	 */
	const validateForm = async () => {
		const [year, month] = birthday.split("/").map(Number);

		setForm((prev) => ({
			...prev,
			birthday: { ...prev.birthday, value: birthday },
			year: { ...prev.year, value: year },
			month: { ...prev.month, value: month },
		}));

		const emailValid = validateEmailAddress();
		const passwordValid = validatePassword(form.password.value.toString());
		const confirmPasswordValid = form.password.value === form.confirmPassword.value;
		const dateValid = isValidDate(year, month);
		const ageValid = validateBirthday(year, month);

		let birthdayError = "";
		let birthdayValid = dateValid && ageValid && birthday.length === 7;
		if (!birthdayValid) {
			if (birthday.length <= 6) {
				birthdayError = globalAny.language.enter_valid_birthday;
			} else {
				birthdayError = globalAny.language.valid_age;
			}
		}

		const hasVoucher = form.voucher.value.toString().length > 0;
		let voucherValid = true;

		if (!automaticVoucherCode && hasVoucher) {
			const voucherResult = await validateVoucherCode();
			voucherValid = voucherResult.valid;
			setForm((prev) => ({
				...prev,
				voucher: { ...prev.voucher, valid: voucherResult.valid, errorMessage: voucherResult.errorMessage },
			}));
		}

		setForm((prev) => ({
			...prev,
			email: { ...prev.email, valid: emailValid, errorMessage: globalAny.language.invalid_email },
			password: { ...prev.password, valid: passwordValid, errorMessage: globalAny.language.password_rules },
			confirmPassword: {
				...prev.confirmPassword,
				valid: confirmPasswordValid,
				errorMessage: globalAny.language.passwords_dont_match,
			},
			birthday: { ...prev.birthday, valid: birthdayValid, errorMessage: birthdayError },
		}));

		if (emailValid && passwordValid && birthdayValid && (voucherValid || !hasVoucher)) {
			setReadyToSaveAccount(true);
		} else {
			setLoading(false);
		}
	};

	/**
	 * Submits the registration form and attempts to save a new account.
	 *
	 * Behavior:
	 * - Sets loading state and clears any existing error summary.
	 * - Extracts year and month from the birthday input.
	 * - Builds the `saveAccount` object with form data, device info, and default flags.
	 * - Calls `registerAccountNoVoucherNeeded` to register the account.
	 * - Handles different response codes:
	 *   - `Code_OK`: Attempts automatic voucher redemption if available, processes user options, or logs in the user.
	 *   - `ACCOUNT_EXIST`: Marks email field as invalid with account exists error.
	 *   - `DEVICE_NOT_ENTITLE` or `HWID_EXIST`: Updates error summary or email field with device entitlement errors.
	 *   - Any other errors trigger `networkConnectionLost`.
	 * - Logs errors using `AppLogger` when exceptions occur.
	 * - Resets loading and `readyToSaveAccount` states in the `finally` block.
	 *
	 * @async
	 * @returns {Promise<void>}
	 */
	const submitFormAndSaveAccount = async () => {
		setLoading(true);
		setErrorSummary("");

		const [year, month] = birthday.split("/");
		const hwid = localStorage.getItem(AsyncStorageKeys.hwid);

		saveAccount = {
			...accountToSave,
			email: form.email.value.toString(),
			password: form.password.value.toString(),
			confirmPassword: form.password.value.toString(),
			deviceIdentifier: localStorage.getItem(AsyncStorageKeys.deviceIdentifier) ?? "WEB-MERCEDES",
			deviceModel: hwid ? "mercedez-benz" : "Web",
			hardwareId: hwid ?? "",
			month: Number(month),
			year: Number(year),
			acceptPrivacy: true,
			acceptTC: true,
			ageChecked: true, // for testing only
			isHwidEncrypted: hwid !== null,
		};

		try {
			const result: any = await registerAccountNoVoucherNeeded(saveAccount);

			const responseCode = result?.response?.data?.responseCode || result?.responseCode;

			if (responseCode === Code_OK) {
				recordAnalytics(EventType.CreateAccount, { email: form.email.value.toString() });

				if (!hwid) {
					const automaticVoucher: any = await automaticVoucherRedemption();
					const code = automaticVoucher?.code;

					if (code) {
						setAutomaticVoucherCode(automaticVoucher);
						const voucherResult: any = await redeemVoucherCode(code, localStorage.getItem(AsyncStorageKeys.session));

						if (voucherResult?.responseCode === Code_OK) {
							localStorage.setItem(AsyncStorageKeys.subscription, JSON.stringify({ endDate: voucherResult.subscriptionExpiry }));
							await processUserOptions();
							setShowVoucherToast(true);
							return;
						}
					}
				}

				await processLogin(saveAccount);
			} else if (responseCode === ACCOUNT_EXIST) {
				setForm({
					...form,
					email: { ...form.email, valid: false, errorMessage: globalAny.language.account_exist },
				});
			} else if (responseCode === DEVICE_NOT_ENTITLE) {
				setErrorSummary(globalAny.language.hwid_account_exist);
				AppLogger.error("Device not entitled error", result);
			} else if (responseCode === HWID_EXIST) {
				setForm({
					...form,
					email: { ...form.email, valid: false, errorMessage: globalAny.language.hwid_account_exist },
				});
			} else {
				networkConnectionLost();
				AppLogger.error("Unexpected registration error", result);
			}
		} catch (ex) {
			networkConnectionLost();
			AppLogger.error("Error saving new account", ex);
		} finally {
			setLoading(false);
			setReadyToSaveAccount(false);
		}
	};

	/**
	 * Props object containing state, handlers, and utility functions
	 * for managing the account form component.
	 *
	 * Properties:
	 * - `showDateModal`: boolean indicating if the date picker modal is visible.
	 * - `setShowDateModal`: function to update `showDateModal`.
	 * - `lastUsedDate`: last selected date value.
	 * - `setLastUsedDate`: function to update `lastUsedDate`.
	 * - `form`: current form state object.
	 * - `setForm`: function to update the form state.
	 * - `showVoucherToast`: boolean controlling voucher toast visibility.
	 * - `automaticVoucherCode`: object containing automatically redeemed voucher info.
	 * - `processToastMessage`: function to handle toast messages.
	 * - `processLogin`: function to log in the user.
	 * - `saveAccount`: object containing account info to save.
	 * - `email`: current email input value.
	 * - `onEnterEmail`: function handling email input changes.
	 * - `secureTextEntry`: boolean controlling password visibility.
	 * - `onPressEye`: function to toggle password visibility.
	 * - `onEnterPassword`: function handling password input changes.
	 * - `birthday`: current birthday input value.
	 * - `setBirthday`: function to update birthday.
	 * - `formatDOB`: function to format the date of birth input.
	 * - `isInCarScreen`: boolean indicating if user is in the car screen.
	 * - `birthdayPattern`: regex pattern used to validate birthday input.
	 * - `errorSummary`: string containing form-level error messages.
	 * - `hasValue`: function to check if a field has a value.
	 */
	const accountFormProps: AccountFormContentProps = {
		showDateModal,
		setShowDateModal,
		lastUsedDate,
		setLastUsedDate,
		form,
		setForm,
		processToastMessage,
		email,
		onEnterEmail,
		secureTextEntry,
		onPressEye,
		onEnterPassword,
		birthday,
		setBirthday,
		formatDOB,
		isInCarScreen,
		birthdayPattern,
		errorSummary,
		hasValue,
	};

	/**
	 * Renders the wide-screen layout for the create account page.
	 *
	 * Layout includes:
	 * - `AccountFormContent` populated with `accountFormProps`.
	 * - Footer section containing:
	 *   - A list of `TouchableButton` components rendered from `touchableButtonData`.
	 *   - A `PrivacyPolicyButton` that triggers `props.onPressPrivacy`.
	 *
	 * @returns {JSX.Element} The wide-screen create account component.
	 */
	const renderWideScreen = () => (
		<WideCreateAccountWrapper>
			<StyledWideContent>
				<AccountFormContent {...accountFormProps} />
			</StyledWideContent>
			<StyledWideFooter>
				<StyledButtonContainer>{touchableButtonData.map(renderTouchableButtonData)}</StyledButtonContainer>
				<PrivacyPolicyButton onPress={props.onPressPrivacy} />
			</StyledWideFooter>
		</WideCreateAccountWrapper>
	);

	/**
	 * Renders the narrow-screen layout for the create account page.
	 *
	 * Layout includes:
	 * - Footer buttons displayed at the top, rendered in reverse order from `touchableButtonData`.
	 * - A `PrivacyPolicyButton` that triggers `props.onPressPrivacy`.
	 * - Main content section containing `AccountFormContent` populated with `accountFormProps`.
	 *
	 * @returns {JSX.Element} The narrow-screen create account component.
	 */
	const renderNarrowScreen = () => (
		<NarrowCreateAccountWrapper>
			<StyledNarrowButton>
				<StyledNarrowCreateButton>{toReversed(touchableButtonData).map(renderTouchableButtonData)}</StyledNarrowCreateButton>
				<PrivacyPolicyButton onPress={props.onPressPrivacy} />
			</StyledNarrowButton>
			<StyledNarrowTextContent>
				<AccountFormContent {...accountFormProps} />
			</StyledNarrowTextContent>
		</NarrowCreateAccountWrapper>
	);

	/**
	 * Effect hook that monitors changes to email, password, and birthday fields.
	 *
	 * Behavior:
	 * - Validates the email using `validateEmail`.
	 * - If email, password, and birthday are all valid, stops the loading state by calling `setLoading(false)`.
	 *
	 * Dependencies:
	 * - `email`: the current email input value.
	 * - `passwordValidated`: boolean indicating if the password input is valid.
	 * - `birthday`: the current birthday input value.
	 */
	useEffect(() => {
		const emailValidated = validateEmail(email);

		if (emailValidated && passwordValidated && birthdayValidated) {
			setLoading(false);
		}
	}, [email, passwordValidated, birthday]);

	/**
	 * Effect hook that updates the local account state when the `accountInfo` prop changes.
	 *
	 * Behavior:
	 * - Merges the existing `accountToSave` state with the latest `props.accountInfo`.
	 *
	 * Dependencies:
	 * - `props.accountInfo`: object containing updated account information from parent component.
	 */
	useEffect(() => {
		setAccountToSave({ ...accountToSave, ...props.accountInfo });
	}, [props.accountInfo]);

	/**
	 * Effect hook that triggers form submission when the account is ready to be saved.
	 *
	 * Behavior:
	 * - Checks if `readyToSaveAccount` is true.
	 * - If true, calls `submitFormAndSaveAccount` to submit the registration form.
	 *
	 * Dependencies:
	 * - `readyToSaveAccount`: boolean indicating if all form validations passed and the account can be saved.
	 */
	useEffect(() => {
		if (!readyToSaveAccount) return;
		submitFormAndSaveAccount();
	}, [readyToSaveAccount]);

	/**
	 * Effect hook that handles post-login navigation and device setup when a presigned URL is available.
	 *
	 * Behavior:
	 * - Runs only if `presignedUrl.topic` exists and the user is not already logged in.
	 * - Sets two nested timeouts (3s then 4s) before executing the navigation logic.
	 * - Determines if the user is in the car screen via localStorage.
	 * - Updates browser history state and hides the welcome splash.
	 * - If in car screen:
	 *   - Retrieves the profile name from AsyncStorage.
	 *   - Updates the device info.
	 *   - Marks the user as logged in and navigates to the home screen.
	 * - Otherwise, navigates to the profile name selection screen.
	 *
	 * Dependencies:
	 * - `presignedUrl`: object containing presigned URL info.
	 */
	useEffect(() => {
		if (!presignedUrl?.topic || isLoggedIn) {
			return;
		}

		setTimeout(() => {
			setTimeout(() => {
				const isInCarScreen = localStorage.getItem(AsyncStorageKeys.isInCarScreen) == "true";
				pushProfileNameStateToBrowserHistory(ProfileNameState.profileNameSelect);
				props.setShowWelcomeSplash(false);
				setIsLogin(true);

				if (isInCarScreen) {
					const profileName = AsyncStorage.getItem(AsyncStorageKeys.profileName);
					updateDevice(profileName);
					setIsLoggedIn(true);
					navigationHomeScreen.navigate(routeHome, {});
					return;
				}

				//@ts-ignore
				navigationProfileNameSelectScreen.navigate(routeProfileNameSelect, { location: Pages.main });
			}, 4000);
		}, 3000);
	}, [presignedUrl]);

	/**
	 * Effect hook that updates the `birthday` field in the form whenever the month or year changes.
	 *
	 * Behavior:
	 * - Checks if `form.month.value` or `form.year.value` is 0. If so, sets `birthday` to an empty string.
	 * - Otherwise, formats `birthday` as "month/year".
	 * - Updates the form state with the new `birthday` value.
	 *
	 * Dependencies:
	 * - `form.month`: the current month value in the form.
	 * - `form.year`: the current year value in the form.
	 */
	useEffect(() => {
		const birthdayField = form.month.value === 0 || form.year.value === 0 ? "" : `${form.month.value}/${form.year.value}`;

		setForm({ ...form, birthday: { ...form.birthday, value: birthdayField } });
	}, [form.month, form.year]);

	return (
		<>
			{isNarrow ? renderNarrowScreen() : renderWideScreen()}
			{visible && (
				<Toast
					visible={visible}
					text={toastMessage}
					label={labelText}
					onDismissSnackBar={onDismissSnackBar}
					onPress={() => onPressToast(labelText)}
				/>
			)}
			{showVoucherToast && (
				<Modal>
					<CustomizeDialogBox
						Header={globalAny.language.voucher_automatically_applied}
						SingleButton
						Body={processToastMessage(automaticVoucherCode)}
						ButtonTextRight={globalAny.language.confirm}
						onPressRight={() => processLogin(saveAccount)}
					/>
				</Modal>
			)}
		</>
	);
};

export default CreateAccountForm;
